import React from 'react';
import { Form } from 'antd';
import { CollapseFilter, FilterForm } from './components';
import { useDataExtractionContext } from '@/context/DataExtraction';
import { useApplicationContext } from '@/context/v1/Application/context';
import type { FormData, InitialValuesForm } from './types';

const { useForm } = Form;

export function Filter() {
	const [form] = useForm<FormData>();
	const { handleOnSetFilter, handleOnClearFilter } = useDataExtractionContext();
	const { organization, company } = useApplicationContext();

	function handleOnClear(): void {
		handleOnClearFilter();
		form.resetFields();
	}

	function handleOnFinish(values: FormData): void {
		const filterValues = {
			...values,
			organization_id: organization?.id || '',
			company_id: company?.id || ''
		};
		handleOnSetFilter(filterValues);
	}

	const initialValues: InitialValuesForm = {
		action_plan_status: 'both'
	};

	return (
		<CollapseFilter>
			<FilterForm form={form} initialValues={initialValues} onFinish={handleOnFinish} onClear={handleOnClear} />
		</CollapseFilter>
	);
}
